import type React from 'react';

interface Props {
  value: string; // config value
  currentValue: string; // value used to select tab
  className?: string;
}

const TabPanel: React.FC<React.PropsWithChildren<Props>> = ({
  children,
  value,
  currentValue,
  className,
}) => {
  const hidden = value !== currentValue;

  return (
    <div className={className} hidden={hidden} role="tabpanel">
      {hidden ? null : children}
    </div>
  );
};

export default TabPanel;
